"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnhancedSortableMultiSelect = void 0;
exports.arrayMove = arrayMove;
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _MultiSelectInput = _interopRequireWildcard(require("./MultiSelectInput"));
var _reactSelect = require("react-select");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _reactSortableHoc = require("react-sortable-hoc");
var _excluded = ["onChange", "classes", "onSortEnd"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*:: import { type ValueType } from './MultiSelectInput';*/ /*:: import { type ThemeType, type StylesheetClasses } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    sortingHelper: {
      // forces cursor to remain in pointer while dragging over text inputs
      pointerEvents: 'auto !important',
      zIndex: theme.zIndex.dragging
    },
    individualElement: {
      cursor: 'pointer'
    }
  };
};
var SortableMultiValue = (0, _injectSheet.default)(Style)((0, _reactSortableHoc.SortableElement)(function (props) {
  var onMouseDown = function onMouseDown(e) {
    // prevents the menu from opening/closing when selecting a value to drag
    e.preventDefault();
    e.stopPropagation();
  };
  var innerProps = {
    onMouseDown: onMouseDown
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactSelect.components.MultiValue, (0, _extends2.default)({
    className: props.classes.individualElement,
    innerProps: innerProps
  }, props)));
}));
function arrayMove(array /*: ValueType*/, from /*: number*/, to /*: number*/) /*: Object[]*/{
  array = array || [];
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
}
var SortableMultiSelect = (0, _reactSortableHoc.SortableContainer)(_MultiSelectInput.default);
/*:: export type SortableMultiSelectInputProps = {
  onSortEnd: (...args: Array<ValueType>) => mixed,
  onChange?: (
    {
      currentTarget: {
        id?: string,
        label: Array<string>,
        name?: string,
        value: ValueType
      }
    },
    ?ValueType,
    ?ValueType
  ) => mixed,
  individualElement: string,
  classes: StylesheetClasses,
  defaultValue?: ValueType,
  value: ValueType
};*/
/*:: type State = {
  value: ValueType
};*/
var EnhancedSortableMultiSelect = exports.EnhancedSortableMultiSelect = /*#__PURE__*/function (_React$Component) {
  function EnhancedSortableMultiSelect(props /*: Object*/) {
    var _this;
    (0, _classCallCheck2.default)(this, EnhancedSortableMultiSelect);
    _this = _callSuper(this, EnhancedSortableMultiSelect, [props]);
    (0, _defineProperty2.default)(_this, "handleSortEnd", function (_ref /*:: */) {
      var oldIndex = _ref /*:: */.oldIndex,
        newIndex = _ref /*:: */.newIndex;
      var onChange = _this.props.onChange;
      var newValue = arrayMove(_this.state.value, oldIndex, newIndex);
      _this.setState({
        value: newValue
      });
      if (typeof onChange === 'function') {
        onChange({
          currentTarget: {
            label: newValue.map(function (label) {
              return label.label;
            }),
            value: newValue.map(function (value) {
              return value.value;
            })
          }
        }, newValue, _this.props.defaultValue);
      }
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (targetValues
    /*: {
          currentTarget: {
            id?: string,
            label: Array<string>,
            name?: string,
            value: ValueType
          }
        }*/
    , valueProp /*: ValueType*/, defaultValue /*: ValueType*/) {
      _this.setState({
        value: valueProp
      });
      if (_this.props.onChange) {
        _this.props.onChange(targetValues, valueProp, defaultValue);
      }
    });
    var defaultProp /*: ValueType*/ = _this.props.defaultValue ? _this.props.defaultValue : [];
    if (Array.isArray(defaultProp)) {
      var filteredArray = defaultProp.filter(function (el) {
        return el.value != null;
      });
      _this.state = {
        value: filteredArray
      };
    } else {
      _this.state = {
        value: defaultProp
      };
    }
    return _this;
  }
  (0, _inherits2.default)(EnhancedSortableMultiSelect, _React$Component);
  return (0, _createClass2.default)(EnhancedSortableMultiSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        classes = _this$props.classes,
        onSortEnd = _this$props.onSortEnd,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(SortableMultiSelect, (0, _extends2.default)({
        className: classes.individualElement,
        onChange: this.handleChange,
        axis: "xy",
        onSortEnd: this.handleSortEnd,
        distance: 4,
        helperClass: classes.sortingHelper
        // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
        ,
        getHelperDimensions: function getHelperDimensions(_ref2) {
          var node = _ref2.node;
          return node.getBoundingClientRect();
        },
        components: {
          MultiValue: SortableMultiValue,
          MultiValueLabel: _MultiSelectInput.MultiValueLabel,
          Menu: _MultiSelectInput.Menu,
          Option: _MultiSelectInput.Option
        },
        value: this.state.value
      }, props));
    }
  }]);
}(_react.default.Component);
EnhancedSortableMultiSelect.displayName = 'SortableMultiSelect';
var _default = exports.default = (0, _injectSheet.default)(Style)(EnhancedSortableMultiSelect);
//# sourceMappingURL=SortableMultiSelectInput.js.map